import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { showApiAlert } from "../../../components/FuncionAlerta";
function ModalDetalleTransferencia({ show, handleClose, transferencia }) {
  const [showDevolucionModal, setShowDevolucionModal] = useState(false);
  const [motivo, setMotivo] = useState("");

  const [detalleTransferencia, setDetalleTransferencia] = useState(null);

  const [loadingDetalle, setLoadingDetalle] = useState(false);
  const [loadingDevolucion, setLoadingDevolucion] = useState(false);
  const displayValue = (value) => value || "-";

  const API_URL = process.env.REACT_APP_URL;

  const SECRET = process.env.REACT_APP_SECRET;
  const formatDate = (timestamp) => {
    if (!timestamp) return "-";

    return `${timestamp.substring(8, 10)}-${timestamp.substring(
      5,
      7
    )}-${timestamp.substring(0, 4)} ${timestamp.substring(11, 19)}`;
  };

  const handleConfirmarDevolucion = async () => {
    if (!motivo) {
      alert("Debe seleccionar un motivo");
      return;
    }

    try {
      setLoadingDevolucion(true);

      const response = await axios.get(
        `${API_URL}/public/v1/shops/SolicitudDevolucion`,
        {
          headers: {
            "SERVICIOS-URBANOS-TOKEN": localStorage.getItem("token"),
          },
          params: {
            origin_id: detalleTransferencia.msg?.metadata.origin_id,
            amount: detalleTransferencia.msg?.movimiento?.balance,
            reason: motivo,
          },
        }
      );


      if (response.data.status == 200) {
        showApiAlert(response.data);
        setMotivo("");
        setShowDevolucionModal(false);
      } else {
        showApiAlert(response.data);
      }
    } catch (error) {
      showApiAlert(error.response.data);
    } finally {
      setLoadingDevolucion(false);
    }
  };
  const [puedeSolicitarDevolucion, setPuedeSolicitarDevolucion] =
    useState(false);

  const obtenerDetalle = async () => {
    if (!show || !transferencia?.origin_id) return;

    try {
      setLoadingDetalle(true);

      const response = await axios.post(
        `${API_URL}/public/Mov/Transfer`,
        {
          origin_id: transferencia.origin_id,
          types: transferencia.movimiento.types,
        },
        {
          headers: {
            "SERVICIOS-URBANOS-TOKEN": localStorage.getItem("token"),
            Secret: SECRET,
          },
        }
      );
      setPuedeSolicitarDevolucion(response.data.boton || false);
      setDetalleTransferencia(response.data || null);
    } catch (error) {
      showApiAlert(error.response.data);
      console.error("Error obteniendo detalle de transferencia", error);
    } finally {
      setLoadingDetalle(false);
    }
  };
  useEffect(() => {
    obtenerDetalle();

    if (!show) {
      setDetalleTransferencia(null);
    }
  }, [show, transferencia]);
  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Detalles del movimiento</Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            opacity: showDevolucionModal ? 0.4 : 1,
            transition: "opacity 0.2s ease",
            pointerEvents: showDevolucionModal ? "none" : "auto",
          }}
        >
          {loadingDetalle ? (
            <div className="text-center py-5">
              <div
                className="spinner-border text-warning"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Cargando...</span>
              </div>

              <p className="mt-3 text-muted mb-0">
                Obteniendo información ...
              </p>
            </div>
          ) : detalleTransferencia ? (
            <>
              <div
                className="p-3 mb-3 "
                style={{
                  background: "#FFF8F0",
                  borderRadius: 16,
                  padding: 20,
                  marginBottom: 18,
                  border: "1px solid #FFD8A8",
                  boxShadow: "0 2px 8px rgba(255, 170, 40, 0.08)",
                }}
              >
                <h6 className="fw-bold mb-3">Información General</h6>

                <div className="row">
                  <div className="col-6 mb-2">
                    <small className="text-muted">Fecha</small>
                    <div>
                      {displayValue(
                        formatDate(detalleTransferencia.msg.timestamp)
                      )}
                    </div>
                  </div>

                  <div className="col-6 mb-2">
                    <small className="text-muted">Tipo</small>
                    <div>
                      {displayValue(detalleTransferencia.msg.movimiento.types)}
                    </div>
                  </div>

                  <div
                    className="text-center py-3 mb-3  "
                    style={{
                      padding: 20,
                      marginBottom: 18,
                      borderTop: "1px solid #FFD8A8",
                      borderBottom: "1px solid #FFD8A8",
                    }}
                  >
                    <small className="text-muted d-block">Balance</small>

                    <h3
                      className="mb-0 fw-bold"
                      style={{
                        fontWeight: 700,
                        color: "#E67E22",
                      }}
                    >
                      $
                      {displayValue(
                        detalleTransferencia.msg.movimiento.balance
                      )}
                    </h3>
                  </div>
                  <p>
                    <strong>Observaciones:</strong>{" "}
                    {displayValue(
                      detalleTransferencia.msg.movimiento.observations
                    )}
                  </p>
                </div>
              </div>

              <hr />
              <div className="row g-3">
                <div className="col-md-6">
                  {/* Destinatario */}
                  <div
                    style={{
                      background: "#FCFCFC",
                      borderRadius: 16,
                      padding: 20,
                      marginBottom: 18,
                      border: "1px solid #FFD8A8",
                      boxShadow: "0 2px 8px rgba(255, 170, 40, 0.08)",
                      height: "100%",
                    }}
                  >
                    <h6
                      style={{
                        color: "#E67E22",
                        fontWeight: 700,
                        marginBottom: 16,
                      }}
                    >
                      Destinatario
                    </h6>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <small className="text-muted">Nombre</small>

                        <div className="fw-semibold">
                          {displayValue(
                            detalleTransferencia.msg.movimiento.nameDest
                          )}{" "}
                          {displayValue(
                            detalleTransferencia.msg.movimiento.lastNameDest
                          )}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <small className="text-muted">CUIT</small>

                        <div>
                          {displayValue(
                            detalleTransferencia.msg.movimiento.cuitDest
                          )}
                        </div>
                      </div>

                      <div className="col-12">
                        <small className="text-muted">CVU</small>

                        <div
                          style={{
                            background: "#fff",

                            padding: "8px 12px",
                            fontFamily: "monospace",
                          }}
                        >
                          {displayValue(
                            detalleTransferencia.msg.movimiento.cvuDest
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  {/* Cuenta Origen */}

                  <div
                    style={{
                      background: "#FCFCFC",
                      borderRadius: 16,
                      padding: 20,
                      border: "1px solid #FFD8A8",
                      boxShadow: "0 2px 8px rgba(17,138,128,0.08)",
                      height: "100%",
                    }}
                  >
                    <h6
                      style={{
                        color: "#E67E22",
                        fontWeight: 700,
                        marginBottom: 16,
                      }}
                    >
                      Cuenta Origen
                    </h6>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <small className="text-muted">Nombre</small>

                        <div className="fw-semibold">
                          {displayValue(
                            detalleTransferencia.msg.movimiento.nameOrig
                          )}{" "}
                          {displayValue(
                            detalleTransferencia.msg.movimiento.lastNameOrig
                          )}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <small className="text-muted">CUIT</small>

                        <div>
                          {displayValue(
                            detalleTransferencia.msg.movimiento.cuitOrig
                          )}
                        </div>
                      </div>

                      <div className="col-12">
                        <small className="text-muted">CVU</small>

                        <div
                          style={{
                            background: "#fff",

                            borderRadius: 8,
                            padding: "8px 12px",
                            fontFamily: "monospace",
                          }}
                        >
                          {displayValue(
                            detalleTransferencia.msg.movimiento.cvuOrig
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <p>No se encontraron detalles.</p>
          )}
        </Modal.Body>

        <Modal.Footer
          style={{
            opacity: showDevolucionModal ? 0.4 : 1,
            transition: "opacity 0.2s ease",
            pointerEvents: showDevolucionModal ? "none" : "auto",
          }}
        >
          {puedeSolicitarDevolucion && (
            <Button
              variant="warning"
              style={{
                color: "#fff",

                fontWeight: 700,
                marginBottom: 16,
              }}
              className="button-confirm"
              onClick={() => setShowDevolucionModal(true)}
            >
              Solicitar devolución
            </Button>
          )}

          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Devolución */}
      <Modal
        show={showDevolucionModal}
        onHide={() => setShowDevolucionModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Solicitar devolución</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Motivo de devolución</Form.Label>

            <Form.Select
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
            >
              <option value="">Seleccione un motivo</option>

              <option value="1">Monto equivocado</option>

              <option value="2">Transferí a la persona incorrecta</option>

              <option value="3">Otro motivo</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDevolucionModal(false)}
          >
            Cancelar
          </Button>

          <Button
            variant="success"
            onClick={handleConfirmarDevolucion}
            disabled={!motivo || loadingDevolucion}
          >
            {loadingDevolucion ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                />
                Procesando...
              </>
            ) : (
              "Confirmar"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalDetalleTransferencia;
